import React, { FC, useEffect, useState } from 'react'
import { Box, Center, Flex, Heading, Image, Spinner, Text } from '@chakra-ui/react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../context/AuthProvider'

const SignUpVerificationPage: FC = () => {
  const { confirm } = useAuthContext()
  const [searchParams, setSearchParams] = useSearchParams()
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const [isTest, setiSTest] = useState(false)
  const navigate = useNavigate()

  const email = searchParams.get('email')
  const code = searchParams.get('code')

  useEffect(() => {
    setError(null)
    setSuccess(null)
    const getSearchParams = async () => {
      try {
        if (email && code) {
          confirm && (await confirm(email as string, code as string))
          setSuccess('Account has been successfully verified')
          setError(null)
          setTimeout(() => {
            navigate('/login')
          }, 2000)
        } else {
          setError(`Invalid token provided, please try again. You will be redirected in 3 seconds`)
          setTimeout(() => {
            navigate('/')
          }, 3000)
          setSuccess(null)
        }
      } catch (e: unknown) {
        let errorMessage = ''
        if (typeof e === 'string') {
          errorMessage = e.toUpperCase()
        } else if (e instanceof Error) {
          errorMessage =
            e.message === 'Failed to fetch' ? 'Something went wrong. Please try again' : e.message
        }
        console.log('Err: ', errorMessage)
        setError(`${errorMessage} You will be redirected in 3 seconds`)
        setTimeout(() => {
          navigate('/')
        }, 3000)
      }
    }
    if (!isTest) {
      getSearchParams()
    }
  }, [])
  return (
    <Flex
      w={'full'}
      minH="100vh"
      direction={'column'}
      gap={'50px'}
      alignItems={'center'}
      justifyContent="center"
    >
      <Heading>Verifying account</Heading>
      <Image src={'/images/logo-new.png'} h={['75px', '100px', '100px', '125px']} />
      <Spinner size="lg" />
      {error && <Text>{error}</Text>}
      {success && <Text>{success}</Text>}
    </Flex>
  )
}

export default SignUpVerificationPage
